import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format as formatDate } from "date-fns";
import { parse } from "date-fns";
import { startOfWeek } from "date-fns";
import { getDay } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import { tr } from "date-fns/locale/tr";
import { useTranslation } from "react-i18next";
import { LoadingOverlay } from "@/components/LoadingOverlay";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "@/styles/calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

const locales = {
  "en-US": enUS,
  "tr-TR": tr,
};

const localizer = dateFnsLocalizer({
  format: formatDate,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const DnDCalendar = withDragAndDrop<any>(Calendar);

interface BaseEvent {}

// @ts-ignore
type BigCalendarEvent<T extends BaseEvent> = {
  title: React.ReactNode;
  start: Date;
  end: Date;
};

export interface BigCalendarProps<T extends BaseEvent> {
  isLoading: boolean;
  events: BigCalendarEvent<T>[];
  YearView: React.FC<any>;
  CalendarItem: React.FC<any>;
  CalendarToolbar: React.FC<any>;
}

export const BigCalendar = <T extends BaseEvent>({
  isLoading,
  events,
  YearView,
  CalendarItem,
  CalendarToolbar,
}: BigCalendarProps<T>) => {
  const { t, i18n } = useTranslation();

  const getCulture = () => {
    return i18n.language === "tr" ? "tr-TR" : "en-US";
  };

  return (
    <LoadingOverlay isLoading={isLoading}>
      <div style={{ height: "100%" }}>
        <DnDCalendar
          localizer={localizer}
          culture={getCulture()}
          events={events}
          formats={{
            timeGutterFormat: "HH:mm",
            eventTimeRangeFormat: ({ start, end }: { start: Date; end: Date }) =>
              `${formatDate(start, "HH:mm")} - ${formatDate(end, "HH:mm")}`,
          }}
          startAccessor="start"
          endAccessor="end"
          selectable
          resizable
          defaultView="month"
          views={{
            week: true,
            month: true,
            agenda: true,
            // @ts-ignore
            year: YearView,
          }}
          style={{ height: "calc(100vh - 100px)" }}
          components={{
            toolbar: CalendarToolbar,
            week: {
              event: CalendarItem,
            },
            month: {
              event: CalendarItem,
            },
          }}
          messages={{
            allDay: t("common.allDay"),
            date: t("common.date"),
            time: t("common.time"),
            event: t("common.event"),
          }}
        />
      </div>
    </LoadingOverlay>
  );
};
